import { ServiceAuthorizationScheme, ServiceSlugs } from '@ply-io/ply-front-shared-utilities';

import { SERVICE_ACTION_COLLECTION_ICONS_FOLDER } from './AppService.const';

// Private

// Public

const getUniqueId = (type, appId, serviceName) => `${type}_${appId}_${serviceName}`;
const doesRequiresAuth = (app) => app?.authorization_scheme !== ServiceAuthorizationScheme.None;
const getIntegrationName = (app) => app?.service_slug || 'tool';
const isNativeIntegration = (app) => !!app.native_integration_platform;

const isSlugOfTables = (slug) => slug === ServiceSlugs.Tables;
const isSlugOfWidget = (slug) => slug === ServiceSlugs.Widgets;
const isSlugOfEndRun = (slug) => slug === ServiceSlugs.EndRun;
const isSlugOfWebhook = (slug) => slug === ServiceSlugs.Webhook;
const isSlugOfScheduledWebhook = (slug) => slug === ServiceSlugs.ScheduledWebhook;
const isSlugOfSubflow = (slug) => slug === ServiceSlugs.SubFlow;
const isSlugOfEmailTemplates = (slug) => slug === ServiceSlugs.EmailTemplates;
const isSlugOfBranches = (slug) => slug === ServiceSlugs.Branches;
const isSlugOfShopify = (slug) => slug === ServiceSlugs.Shopify;
const isSlugOfLoop = (slug) => slug === ServiceSlugs.Loop;
const isServiceTestAgainBlocked = (slug) => slug === ServiceSlugs.GmailAttachment;
const isSlugOfSidebar = (slug) => slug === ServiceSlugs.Sidebar;
const isSlugOfTransactionalEmails = (slug) => slug === ServiceSlugs.TransactionalEmails;
const doesAppSupportAccountWorkspaces = (app) => app?.support_workspace_extraction;
const canSkipPlacementCredentials = (app) => app?.can_skip_context_auth;
const getAppMainHost = (app) => app.hosts[0];
const isSlugOfNotification = (slug) => slug === ServiceSlugs.Notification;
const getServiceActionCollectionIconName = (serviceSlug) => `${SERVICE_ACTION_COLLECTION_ICONS_FOLDER}/${serviceSlug}`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getServiceWorkspaceResourceTitle = (app) => 'workspace'; // todo - add field on service that tells us the workspace resource title (workspace/account/whatever it can be)

const AppService = {
	getUniqueId,
	doesRequiresAuth,
	getIntegrationName,
	isNativeIntegration,
	isServiceTestAgainBlocked,

	isSlugOfTables,
	isSlugOfWidget,
	isSlugOfEndRun,
	isSlugOfWebhook,
	isSlugOfScheduledWebhook,
	isSlugOfSubflow,
	isSlugOfEmailTemplates,
	isSlugOfBranches,
	isSlugOfShopify,
	isSlugOfLoop,
	isSlugOfSidebar,
	isSlugOfTransactionalEmails,
	doesAppSupportAccountWorkspaces,
	canSkipPlacementCredentials,
	getAppMainHost,
	isSlugOfNotification,
	getServiceActionCollectionIconName,
	getServiceWorkspaceResourceTitle,
};

export default AppService;
